import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'cms-aggregate-entries',
  name: '聚合入口',
  icon: '聚',
  group: 'CMS通用',
  description: '信息流页的聚合页入口。',
  defaultProps: {
    iconShape: 'circle',
    entries: [
      { label: '栏目', icon: '栏', linkTarget: '/pages/cms/catalogs' },
      { label: '话题', icon: '话', linkTarget: '/pages/cms/topic' },
      { label: '专题', icon: '专', linkTarget: '/pages/cms/special' },
      { label: '合集', icon: '集', linkTarget: '/pages/cms/collection' }
    ]
  }
}
